export enum PERMISSIONS {
  VENUE_MANAGEMENT = "venue_management",
  ORDER_SETTINGS_MANAGEMENT = "order_settings_management",
  MENU_MANAGEMENT = "menu_management",
  BILLING_AND_PAYMENT = "billing_and_payment_management",
  DISCOUNT_AND_PROMOTIONS = "discount_and_promotions_management",
  REPORTING = "reporting",
  REFUNDS = "refund_management",
  ORDER_PROCESSING = "order_processing",
  USER_MANAGEMENT = "user_management",
  ADMIN = "admin",
  SEND_NEW_PASSWORD = "send_new_password",
}

export const PERMISSIONS_LIST = {
  venue_management: {
    requiredForSuperuser: true,
    adminOnly: false,
  },
  order_settings_management: {
    requiredForSuperuser: true,
    adminOnly: false,
  },
  menu_management: {
    requiredForSuperuser: true,
    adminOnly: false,
  },
  billing_and_payment_management: {
    requiredForSuperuser: true,
    adminOnly: false,
  },
  discount_and_promotions_management: {
    requiredForSuperuser: false,
    adminOnly: false,
  },
  reporting: {
    requiredForSuperuser: true,
    adminOnly: false,
  },
  refund_management: {
    requiredForSuperuser: false,
    adminOnly: false,
  },
  order_processing: {
    requiredForSuperuser: false,
    adminOnly: false,
  },
  user_management: {
    requiredForSuperuser: true,
    adminOnly: false,
  },
  admin: {
    requiredForSuperuser: false,
    adminOnly: true,
  },
  send_new_password: {
    requiredForSuperuser: true,
    adminOnly: true,
  },
};
